import React, { Component } from 'react';
import store from "store/store";
import queryString from 'query-string';
import Joi from "joi-browser";
import SettingsTab from "components/__new/settings/tab";
import DropdownNew from "utils/dropdown";
import { default as ReactSelect, components } from "react-select";
import { Dialog } from '@headlessui/react';
import Pagination from "components/__new/common/pagination";
import logger from "utils/logger";
import { nameInitials } from 'utils/nameInitials.jsx';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import Table from "components/__new/common/Table";
import * as admin from "store/entities/settingsAdmin/action";
import * as auth from "store/auth/user/action";
import Maybe from "components/__new/common/Maybe";


const Option = (props) => {
    return (
        <div className="p-0">
            <components.Option {...props}>
                <div className="-mx-2 -my-1.5 p-4 text-sm flex space-x-2 justify-between border rounded-sm">
                    <div className="max-w-xs">
                        <div className="font-semibold">
                            {props.label}

                            {props.data.accountType === "main" &&
                                <label className="label text-white ml-1 bg-black relative -top-0.5" style={{padding: "0px 8px"}}>Main</label>
                            }
                        </div>
                        <div className="text-fade text-xs">
                            {props.data.firstName + " " + props.data.lastName} ({props.data.jobTitle})
                        </div>
                    </div>
                    <div className="w-5">
                        <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null}
                            className="w-5 h-5 form-checkbox rounded-full"
                        />
                    </div>
                </div>
            </components.Option>
        </div>
    );
};

const ValueContainer = ({ children, ...props }) => {
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && (
            <span
              className="fa fa-search"
              aria-hidden="true"
              style={{ position: "absolute", left: 10, color: "#aaa" }}
            />
          )}
          {children}
        </components.ValueContainer>
      )
    );
};

const ReactSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: "#333",
        background: "#fff",
        cursor: "pointer",
        "&:hover": {
            background: "#eee",
        }
    }),
    valueContainer: base => ({
        ...base,
        paddingLeft: 32,
        overflowX: 'scroll',
        flexWrap: 'unset',
    }),
    multiValue: (base) => ({
        ...base,
        flex: '0 0 auto',
    }),
    menu: (base) => ({
        ...base,
        width: "max-content",
        minWidth: "100%"
   }),
};


class Admin extends Component {
    constructor(props) {
        super(props);
        this.completeButtonRef = React.createR
    }

    state = {
        getAllAdminParams: {
            page: 1,
            limit: 20,
            status: "",
            download: false
        },
        newAdminForm: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            jobTitle: "",
        },
        showAddAdmin: false,
        assignBusinessParams: {
            admin: {},
        },
        subAccountParams: {
            page: 1,
            limit: 50,
            download: false
        },
        showModalAssignBusiness: false,
        subAccountList: [],
        subAccountListSelected: [],
        errors: {},
        storeUnsubscribe: "",
    }


    toggleShowAddAdmin = () => {
        this.setState({showAddAdmin: !this.state.showAddAdmin});
    }


    formChange = (e) => {
        const formValue = {...this.state.newAdminForm};
        formValue[e.currentTarget.name] = e.currentTarget.value;
        this.setState({newAdminForm: formValue});
    }

    
    schema = {
        firstName: Joi.string().required().label("First Name").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's first name";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        lastName: Joi.string().required().label("Last Name").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's last name";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        email: Joi.string().email().required().label("Email Address").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's email address";
                        break;
                    case "string.email":
                        err.message = "Please enter the admin's email address";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        phoneNumber: Joi.string().min(11).max(11).required().label("Phone Number").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter admin's phone number";
                        break;
                    case "string.min":
                        err.message = `Please enter 11 digits for admin's phone number`;
                        break;
                    case "string.max":
                        err.message = `Please enter 11 digits for admin's phone number`;
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        jobTitle: Joi.string().required().label("Job Title").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's job title";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
    }


    validate = () => {
        const options = { abortEarly: false };
        const result = Joi.validate(this.state.newAdminForm, this.schema, options);
        // console.log(result);
        const error = result.error;
        if (!error) return null;
    
        const errors = {};
        for (let item of result.error.details){
            errors[item.path[0]] = item.message;
        }
        return errors;
    };


    submitForm = async e => {
        e.preventDefault();
        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors){
            // console.log(errors);
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            this.props.createAdmin(this.state.newAdminForm);
        }
    }
    

    getAllAdmin = () => {
        const qs = queryString.parse(this.props.location.search);
        let getAllAdminParams = {...this.state.getAllAdminParams};
        
        if ((qs.page !== undefined) && (!isNaN(qs.page)) && (qs.page > 0)){
            getAllAdminParams = {...getAllAdminParams, page: qs.page};
        }
        else{
            getAllAdminParams = {...getAllAdminParams, page: 1};
        }
        
        this.setState({getAllAdminParams});
        this.props.getAllAdmin(getAllAdminParams);
    }


    resendInvite = (email) => {
        toast("Resending invite to " + email);
        this.props.resendInvite(email);
    }


    openModalAssignBusiness = (admin) => {
        const {subAccountParams, showModalAssignBusiness} = this.state;
        const {subAccountsLoading, subAccounts} = this.props;
        if (subAccounts?.accounts?.docs){
            this.openModalRenderAssignBusiness(admin);
        }
        else{
            if (subAccountsLoading === false){
                this.props.getSubAccounts(subAccountParams).then(() => {
                    this.openModalRenderAssignBusiness(admin);
                });
            }
            else{
                this.unsubscribe = store.subscribe(() => {
                    if (store.getState().auth.user.subAccountsLoading === false){
                        this.unsubscribe();
                        this.openModalRenderAssignBusiness(admin);
                    }
                });
                this.setState({storeUnsubscribe: this.unsubscribe});
            }
        }
        this.setState({showModalAssignBusiness: !showModalAssignBusiness});
    }


    openModalRenderAssignBusiness = (admin) => {
        const { subAccounts } = this.props;
        let subAccountListSelected = [];

        const assignBusinessParams = {
            admin,
        }
        subAccountListSelected = subAccounts?.accounts?.docs.map((subAccount) => {
            if (admin.employerList.includes(subAccount._id)){
                return {label: subAccount.companyName, value: subAccount._id, ...subAccount};
            }
            return null;
        })

        this.setState({assignBusinessParams, subAccountListSelected});
    }

    
    renderSubBusinessesList = () => {
        let subAccountList = [];
        const { subAccounts } = this.props;

        if (subAccounts?.accounts?.totalDocs > 0){
            if (subAccounts?.accounts?.docs){
                subAccounts?.accounts?.docs.map((subAccount) => {
                    const data = {label: subAccount.companyName, value: subAccount._id, ...subAccount};
                    subAccountList.push(data);
                    return null;
                });
                this.setState({subAccountList});
            }
        }
    }


    populateSubBusinesses = () => {
        const {subAccountParams} = this.state;
        const {subAccountsLoading, subAccounts} = this.props;
        if (subAccounts?.accounts?.docs){
            this.renderSubBusinessesList();
        }
        else{
            if (subAccountsLoading === false){
                this.props.getSubAccounts(subAccountParams).then(() => {
                    this.renderSubBusinessesList();
                });
            }
            else{
                this.unsubscribe = store.subscribe(() => {
                    if (store.getState().auth.user.subAccountsLoading === false){
                        this.unsubscribe();
                        this.renderSubBusinessesList();
                    }
                });
                this.setState({storeUnsubscribe: this.unsubscribe});
            }
        }
    }


    subAccountListSelected = (subAccount) => {
        this.setState({subAccountListSelected: subAccount});
    }


    submitAssignBusinessForm = (e) => {
        e.preventDefault();
        const {assignBusinessParams, subAccountListSelected, showModalAssignBusiness} = this.state;
        const adminId = assignBusinessParams.admin._id;
        const subAccounts = subAccountListSelected.map((account) => {
            return account._id;
        })
        let params = {"employerList": subAccounts};
        this.props.adminAssignBusiness(adminId, params).then(() => {
            this.getAllAdmin();
            this.setState({showModalAssignBusiness: !showModalAssignBusiness});
        })
    }


    closeModal = (action) => {
        this.setState({showModalAssignBusiness: action});
    }


    getSubBusinessAccess = () => {
        const {user} = this.props;
        if (
            (user.employer.accountType && user.employer.accountType === "main") ||
            (user.employer.accountType && user.employer.accountType === "sub" && user.employer.mainAccount && Object.keys(user.employer.mainAccount).length > 0) ||
            (user.employer.alias && user.employer.alias === true)
        ){
            return true;
        }
        return false;
    }


    componentDidMount() {
        if(this.props.user?.employer?.products?.includes("ON_DEMAND_PAY")) {
            this.getAllAdmin();
            if (this.getSubBusinessAccess() === true){
                this.populateSubBusinesses();
            }
        }
    }
    

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.getAllAdmin();
        }
        if (this.props.adminCreateSuccess === true) {
            logger("employer-add-admin", this.props.user?.employer);
            this.toggleShowAddAdmin();
            this.props.resetAdminCreateSuccess();
            const emptyAdminForm = {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                jobTitle: "",
            };
            this.setState({newAdminForm:emptyAdminForm});
            this.props.history.push(this.props.location.pathname);
        }
        if (this.props.reloadPage === true) {
            setTimeout(()=>{
                this.props.resetReloadPage();
                this.props.history.replace(this.props.location.pathname + this.props.location.search);
            },1000);
        }
    }


    componentWillUnmount() {
        const storeUnsubscribe = this.state.storeUnsubscribe;
        if ((storeUnsubscribe !== "") && (storeUnsubscribe !== undefined) && (storeUnsubscribe !== null)){
            storeUnsubscribe();
        }
    }


    render() { 
        const data = this.props.allAdmin;
        const {newAdminForm, subAccountList, subAccountListSelected, assignBusinessParams, showModalAssignBusiness} = this.state;
        const {user, subAccountsLoading, adminAssignBusinessLoading} = this.props;

        return ( 
            <div>

                <DynamicHeadTag
                    headerText="Administrators | Settings"
                    headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
                />

                {(showModalAssignBusiness === true) &&
                    <Dialog open={showModalAssignBusiness} initialFocus={this.completeButtonRef} onClose={() => this.closeModal(false)} className="fixed z-10 inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center min-h-screen">
                            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

                            <div className="w-full max-w-lg mx-auto relative bg-white rounded overflow-hidden">
                                <div className="h-12 px-4 bg-ep-primary flex justify-between overflow-hidden">
                                    <div className="my-auto text-white">
                                        Assign {assignBusinessParams.admin.firstName} {assignBusinessParams.admin.lastName} to business(es)
                                    </div>
                                    <div onClick={() => this.closeModal(false)} ref={this.completeButtonRef} className="w-7 h-7 flex my-auto border group hover:bg-red-400 hover:border-red-400 border-white rounded-lg cursor-pointer">
                                        <FontAwesomeIcon icon="times" className="text-white m-auto" />
                                    </div>
                                </div>

                                <form className="p-6" onSubmit={this.submitAssignBusinessForm}>

                                    <div className="sub-account-list h-96">
                                        <ReactSelect
                                            options={subAccountList}
                                            value={subAccountListSelected}
                                            onChange={this.subAccountListSelected}
                                            placeholder="Select business(es)"
                                            noOptionsMessage={() => (subAccountsLoading ? "Loading businesses..." : "No businesss yet")}
                                            styles={ReactSelectStyles}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            menuIsOpen={true}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            allowSelectAll={true}
                                        />
                                    </div>
                                    
                                    <div className="mt-12 flex justify-end space-x-2">
                                        <button onClick={() => this.closeModal(false)} className="btn btn-transparent-black">Close</button>
                                        <button type="submit" className="btn btn-ep-primary" disabled={adminAssignBusinessLoading}>
                                            <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (adminAssignBusinessLoading?"inline":"hidden")} />
                                            Assign Business
                                        </button>
                                    </div>

                                </form>

                            </div>

                        </div>
                    </Dialog>
                }


                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Settings
                        </div>
                    </div>
                    <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
                </div>


                <div className="mt-6 border-b">
                    <SettingsTab />
                </div>


                <div className={(this.state.showAddAdmin?"mt-6 space-y-6 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-6":"hidden")}>
                    <form className="box col-span-2" onSubmit={this.submitForm}>

                        <div className="flex justify-between">
                            <div className="font-bold text-gray-600">
                                Add New Administrator
                            </div>
                            <div>
                                <div onClick={this.toggleShowAddAdmin} className="w-8 h-8 -mt-1 flex border group hover:bg-red-400 hover:border-red-400 border-gray-500 rounded-lg cursor-pointer">
                                    <FontAwesomeIcon icon="times" className="text-gray-500 group-hover:text-white m-auto" />
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 sm:grid sm:grid-cols-2 sm:gap-x-6">
                            
                            <div className="form-group">
                                <label>
                                    First name
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="text" name="firstName" placeholder="Enter First Name" className="form-input" value={newAdminForm.firstName} onChange={this.formChange} />
                            </div>

                            <div className="form-group">
                                <label>
                                    Last name
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="text" name="lastName" placeholder="Enter Last Name" className="form-input" value={newAdminForm.lastName} onChange={this.formChange} />
                            </div>
                            
                            <div className="form-group col-span-2">
                                <label>
                                    Email Address
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="email" name="email" placeholder="Enter Employee Email Address" className="form-input" autoComplete="off" value={newAdminForm.email} onChange={this.formChange} />
                            </div>

                            <div className="form-group">
                                <label>
                                    Phone Number
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="tel" name="phoneNumber" placeholder="Enter Admin Phone Number" className="form-input" autoComplete="off" value={newAdminForm.phoneNumber} onChange={this.formChange} />
                            </div>

                            <div className="form-group">
                                <label>
                                    Job Title
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="text" name="jobTitle" placeholder="Enter Job Title" className="form-input" value={newAdminForm.jobTitle} onChange={this.formChange} />
                            </div>

                        </div>

                        <button type="submit" className="btn btn-lg btn-ep-primary mt-2" disabled={this.props.adminCreateLoading}>
                            <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (this.props.adminCreateLoading?"inline":"hidden")} />
                            Send Invite
                        </button>

                    </form>         

                    <div className="box">
                        <div className="font-bold text-gray-600">
                            Recently Added Administrators
                        </div>

                        <div className="mt-5 space-y-4 max-h-96 overflow-auto">

                            {(this.props.loading === true) && 
                                <div className="lg:mt-16">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="circle-notch" spin />
                                        <div className="font-bold uppercase">
                                            Loading
                                        </div>
                                    </div>
                                </div>
                            }
                            
                            {((this.props.loading === false) && (!data.docs)) && 
                                <div className="lg:mt-16">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="unlink" />
                                        <div className="font-bold uppercase">
                                            An error occurred
                                            <br />
                                            Please try again later.
                                        </div>
                                    </div>
                                </div>
                            }
                            
                            {((this.props.loading === false) && (data.docs) && (data.docs.length <= 0)) && 
                                <div className="lg:mt-16">

                                    {(data.page <= data.totalPages) &&
                                        <div className="table-info">
                                            <FontAwesomeIcon icon="list" />
                                            <div className="font-bold uppercase">
                                                No results found
                                            </div>
                                        </div>
                                    }
                                    
                                    {(data.page > data.totalPages) &&
                                        <div className="table-info">
                                            <FontAwesomeIcon icon="exclamation-triangle" />
                                            <div className="font-bold uppercase">
                                                Invalid Page Number
                                            </div>
                                            <div className="mt-2">
                                                <Link to="?page=1" className="btn btn-ep-primary btn-sm mx-auto">Goto Page 1</Link>
                                            </div>
                                        </div>
                                    }
                                    
                                </div>
                            }

                            {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                                data.docs.map((admin, index) =>

                                    
                                    <div key={index} className="p-3 flex rounded-lg shadow-sm border border-gray-200">
                                        <div className="w-11 h-11 mr-3 my-auto rounded-full flex text-lg font-bold flex-shrink-0 bg-ep-primary">
                                            <span className="m-auto text-white">
                                                {nameInitials(admin.firstName, admin.lastName)}
                                            </span>
                                        </div>
                                        <div className="flex overflow-hidden">
                                            <div className="my-auto overflow-hidden">
                                                <div className="font-bold text-gray-600 capitalize ellipsis">
                                                    {admin.firstName} {admin.lastName}
                                                </div>
                                                <div className="-mt-1 text-sm text-gray-400 ellipsis">
                                                    {admin.email}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )
                            }
                        </div>
                    </div>
                    
                </div>


                <div className="mt-8 box">
                    <div className="-mt-4">

                        <div className="w-full py-3 sm:py-0 sm:h-16 sm:flex">
                            <div className="w-full sm:w-1/2 uppercase font-bold my-auto">
                                Full Administrators List
                            </div>
                            <div className="w-full pt-2 sm:pt-0 sm:w-1/2 my-auto">
                                <div className="p-1 relative flex-shrink-0">
                                    <Maybe condition={this.props.user.employer.userType === 'employer'}>
                                        <button disabled={!this.props.user?.employer?.products?.includes("ON_DEMAND_PAY")} type="button" className={(this.state.showAddAdmin?"hidden":"btn btn-sm btn-ep-primary sm:float-right")} onClick={this.toggleShowAddAdmin}>
                                            Add New Administrator
                                        </button>
                                    </Maybe>
                                </div>
                            </div>
                        </div>

                        <div>
                            <Table>
                                <Table.Head>
                                    <th>Full Name</th>
                                    <th>Email Address</th>
                                    <th>Phone Number</th>
                                    <th>Job Title</th>
                                    <th>Status</th>
                                    <Maybe condition={this.props.user.employer.userType === 'employer'}>
                                        <th>Actions</th>
                                    </Maybe>
                                </Table.Head>
                                <Table.Body>

                                    {(this.props.loading === true) && 
                                        <tr>
                                            <td colSpan="6">
                                                <div className="table-info">
                                                    <FontAwesomeIcon icon="circle-notch" spin />
                                                    <div className="font-bold uppercase">
                                                        Loading
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    
                                    {((this.props.loading === false) && (!data.docs)) && 
                                        <tr>
                                            <td colSpan="6">
                                                <div className="table-info">
                                                    <FontAwesomeIcon icon="unlink" />
                                                    <div className="font-bold uppercase">
                                                        An error occurred
                                                        <br />
                                                        Please try again later.
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    
                                    {((this.props.loading === false) && (data.docs) && (data.docs.length <= 0)) && 
                                        <tr>
                                            <td colSpan="6">
                                                
                                                {(data.page <= data.totalPages) &&
                                                    <div className="table-info">
                                                        <FontAwesomeIcon icon="list" />
                                                        <div className="font-bold uppercase">
                                                            No results found
                                                        </div>
                                                    </div>
                                                }
                                                
                                                {(data.page > data.totalPages) &&
                                                    <div className="table-info">
                                                        <FontAwesomeIcon icon="exclamation-triangle" />
                                                        <div className="font-bold uppercase">
                                                            Invalid Page Number
                                                        </div>
                                                        <div className="mt-2">
                                                            <Link to="?page=1" className="btn btn-ep-primary btn-sm mx-auto">Goto Page 1</Link>
                                                        </div>
                                                    </div>
                                                }

                                            </td>
                                        </tr>
                                    }

                                    {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                                        data.docs.map((admin, index) =>
                                        <tr key={index}>
                                            <td>
                                                <div className="font-medium capitalize">
                                                    {admin.firstName} {admin.lastName}
                                                </div>
                                            </td>
                                            <td>
                                                {admin.email}
                                            </td>
                                            <td>
                                                {admin.phoneNumber}
                                            </td>
                                            <td>
                                                {admin.jobTitle}
                                            </td>
                                            <td>
                                                {(admin.disabled === true) &&
                                                    <div className="label label-red">
                                                        Inactive
                                                    </div>
                                                }
                                                {(admin.disabled === false) &&
                                                    <div className="label label-green">
                                                        Active
                                                    </div>
                                                }
                                            </td>
                                            <Maybe condition={this.props.user.employer.userType === 'employer'}>
                                            <td>
                                                <DropdownNew>
                                                    <></>
                                                    <div>
                                                        {(admin._id === this.props.user?.employer._id) &&
                                                            <Link to="/account/profile" className="dropdown-item">Edit</Link>
                                                        }
                                                        {(admin._id !== this.props.user?.employer._id) &&
                                                            <>
                                                                <Link to={"/settings/administrators/edit/" + admin._id} className="dropdown-item">Edit</Link>
                                                                <div onClick={() => this.resendInvite(admin.email)} className="dropdown-item">Resend Invite</div>
                                                                {(user?.employer?.userType === "employer") && (user?.employer?.accountType === "main") && (user?.employer?.products?.includes("ON_DEMAND_PAY")) &&
                                                                    <div onClick={() => this.openModalAssignBusiness(admin)} className="dropdown-item">Assign Business</div>
                                                                }
                                                                {(admin.disabled) &&
                                                                    <div onClick={() => this.props.enableAdmin(admin._id)} className="dropdown-item">Enable</div>
                                                                }
                                                                {(!admin.disabled) &&
                                                                    <div onClick={() => this.props.disableAdmin(admin._id)} className="dropdown-item">Disable</div>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </DropdownNew>
                                            </td>
                                            </Maybe>
                                        </tr>
                                    )}

                                </Table.Body>
                            </Table>
                        </div>

                        {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                            <div>
                                <Pagination data={data} url={this.props.location.search} />
                            </div>
                        }

                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    user: state.auth.userPersist.data,
    loading: state.entities.settingsAdmin.loading,
    allAdmin: state.entities.settingsAdmin.allAdmin,
    adminCreateLoading: state.entities.settingsAdmin.adminCreateLoading,
    adminCreateSuccess: state.entities.settingsAdmin.adminCreateSuccess,
    reloadPage: state.entities.settingsAdmin.reloadPage,
    adminAssignBusinessLoading: state.entities.settingsAdmin.adminAssignBusinessLoading,
    adminAssignBusinessStatus: state.entities.settingsAdmin.adminAssignBusinessStatus,

    getCompanyInfoLoading: state.entities.settingsInfo.getLoading,
    companyInfo: state.entities.settingsInfo.companyInfo.company,
    subAccountsLoading: state.auth.user.subAccountsLoading,
    subAccounts: state.auth.user.subAccounts,
});

const mapDispatchToProps = (dispatch) => ({
    getAllAdmin: (params) => dispatch(admin.getAllAdmin(params)),
    createAdmin: (params) => dispatch(admin.createAdmin(params)),
    resetAdminCreateSuccess: () => dispatch(admin.resetAdminCreateSuccess()),
    enableAdmin: (id) => dispatch(admin.updateAdminStatus(id, "enabled")),
    disableAdmin: (id) => dispatch(admin.updateAdminStatus(id, "disabled")),
    deleteAdmin: (id) => dispatch(admin.deleteAdmin(id)),
    resendInvite: (email) => dispatch(admin.resendInvite(email)),
    adminAssignBusiness: (id, params) => dispatch(admin.adminAssignBusiness(id, params)),
    resetReloadPage: () => dispatch(admin.resetReloadPage()),

    getSubAccounts: (params) => dispatch(auth.getSubAccounts(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Admin);